module.exports = __webpack_public_path__ + "static/media/cow-transparent.53eca326.gif";